import { Box, Typography } from '@mui/material';

import { Link01Icon } from '@/components/icons/Link01Icon';
import { COLORS } from '@/styles/tokens/colors';

export interface AssetProviderFormLinkIndicatorProps {
  providerName: string;
}

export function AssetProviderFormLinkIndicator({
  providerName,
}: AssetProviderFormLinkIndicatorProps) {
  return (
    <Box textAlign="center">
      <Box my={4}>
        <Link01Icon size={80} color={COLORS.TEXT.SECONDARY} />
      </Box>
      <Typography variant="body-s">
        Valuation data will be automatically captured from {providerName}
      </Typography>
    </Box>
  );
}
